<script setup lang="ts">
import ToggleButton from 'primevue/togglebutton';
import { globalKeys } from 'assets/data/global-keys';

const { $storageService } = useServices();
const enabled = ref<boolean>(false);

const toggleDebug = (value: boolean) => {
  enabled.value = value;
  if (value)
    $storageService.setSessionStorage({
      key: globalKeys.developerConfigKeys.debugWebSocket,
      data: true,
    });
  else
    $storageService.removeSessionStorage({
      key: globalKeys.developerConfigKeys.debugWebSocket,
    });
};

onMounted(() => {
  enabled.value = !!$storageService.getSessionStorage({
    key: globalKeys.developerConfigKeys.debugWebSocket,
  });
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <p class="text-xs text-base-priority my-1">
      In order to see websocket debug messages in the console, you need to
      toggle the button below.
    </p>
    <ToggleButton
      on-label="Websocket debug on"
      off-label="Websocket debug off"
      class="p-2 rounded-lg std-border text-sm truncate"
      :class="[
        {
          'bg-base text-base-priority stacked-border': !enabled,
          'bg-success-500 text-light-50 font-bold': enabled,
        },
      ]"
      :model-value="enabled"
      @change="toggleDebug(!enabled)"
    />
  </div>
</template>
